/**
 * LocationFilterPanel - Horizontal filter strip for location heatmap
 */

import React from 'react';

const TYPE_OPTIONS = [
  { value: '', label: 'All Types' },
  { value: 'call', label: 'Call' },
  { value: 'chat', label: 'Chat' },
  { value: 'email', label: 'Email' },
];

const SENTIMENT_OPTIONS = [
  { value: '', label: 'All Sentiments' },
  { value: 'very_positive', label: 'Very Positive' },
  { value: 'positive', label: 'Positive' },
  { value: 'neutral', label: 'Neutral' },
  { value: 'negative', label: 'Negative' },
  { value: 'very_negative', label: 'Very Negative' },
];

const URGENCY_OPTIONS = [
  { value: '', label: 'All Urgencies' },
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'critical', label: 'Critical' },
];

const selectClasses = 'pl-3 pr-8 py-1.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-primary-500 focus:border-transparent';

const LocationFilterPanel = ({ typeFilter, sentimentFilter, urgencyFilter, onTypeChange, onSentimentChange, onUrgencyChange }) => (
  <div className="flex items-center space-x-3">
    <select
      value={typeFilter}
      onChange={(e) => onTypeChange(e.target.value)}
      className={selectClasses}
      aria-label="Filter by interaction type"
    >
      {TYPE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>

    <select
      value={sentimentFilter}
      onChange={(e) => onSentimentChange(e.target.value)}
      className={selectClasses}
      aria-label="Filter by sentiment"
    >
      {SENTIMENT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>

    <select
      value={urgencyFilter}
      onChange={(e) => onUrgencyChange(e.target.value)}
      className={selectClasses}
      aria-label="Filter by urgency"
    >
      {URGENCY_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </div>
);

export default React.memo(LocationFilterPanel);
